import {
  defineAction,
  createActionsAndTypes,
  type ActionsUnion,
} from '../actionUtils';
import type {ElementInteractions} from './types';

export const {
  creators: ix3ElementTrackerCreators,
  actionTypes: ix3ElementTrackerActionTypes,
} = createActionsAndTypes({
  /**
   * Updates the complete map of element interactions.
   * Dispatched by IX3ElementTrackerEngine after rebuilding the map.
   */
  ix3ElementInteractionsUpdated: defineAction(
    'IX3_ELEMENT_INTERACTIONS_UPDATED'
  )<{
    /** Complete map of stringified nativeIdPath to interaction IDs */
    elementInteractions: ElementInteractions;
    /**
     * Complete map of stringified nativeIdPath to the interactions that element
     * CONTROLS — a popover's buttons, a navbar's hamburger. Rebuilt in the same
     * pass, so the two always describe the same moment.
     */
    elementTriggerControls: ElementInteractions;
  }>(),

  /**
   * Clears all tracked elements.
   * Dispatched when page switches or explicit reset needed.
   */
  ix3ElementTrackerCleared: defineAction('IX3_ELEMENT_TRACKER_CLEARED')<void>(),
});

export type IX3ElementTrackerAction = ActionsUnion<
  typeof ix3ElementTrackerCreators
>;
